import { StorageService } from '../../../services/storage/storage.service';
import { AppStateService } from '../../../services/appState/app-state.service';
import { Injectable } from '@angular/core';
import { FilterParams, RepositoryService } from '../../../helpers/crud/repository.service';
import { WancomHttpService } from '../../../services/wancom-http/wancom-http.service';
import { WaitingService } from '../../layout/waiting/waiting.service';
import { OrganizationType } from '../../../services/organization/organization.service';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class OrganizationTypeService extends RepositoryService<OrganizationType> {
	constructor(
		http: WancomHttpService,
		waiting$: WaitingService,
		appStateService: AppStateService,
		storageService: StorageService
	) {
		super(http, waiting$, 'companyType', appStateService, storageService, 'orderTypes');
	}

	getCompanyTypes() {
		let filterParams =  new CompanyTypeFilterParams();
		filterParams.name = null;
		filterParams.page= 0;
		filterParams.pageSize=50;
        return this.http.post<any>('companyType/type', filterParams, environment.apiBaseStore)
           
    }
}


@Injectable()
export class CompanyTypeFilterParams extends FilterParams {
	name: string;
}
